import PreferenceColumn from "./PreferenceColumn";

export default PreferenceColumn;
